// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1CBcL","logo":"Footer_logo__20eb1"};